import { enrollmentFilterFields } from 'consts/filters/enrollment/enrollmentFilterFields';
import { FiltersParams } from 'types';
import { ApplicationStatus, EnrollmentFilters } from 'types/enrollment/enrollment';

export const parseFilterParamsIntoGetEnrollmentFiltersValues: (
    filterParams: FiltersParams,
    searchFilterParam: string,
) => EnrollmentFilters = (filterParams, searchFilterParam) => ({
    status: filterParams[enrollmentFilterFields.status]
        ? (filterParams[enrollmentFilterFields.status] as ApplicationStatus)
        : undefined,
    search: searchFilterParam,
    fromYear: filterParams[enrollmentFilterFields.fromYear]
        ? Number(filterParams[enrollmentFilterFields.fromYear])
        : undefined,
    toYear: filterParams[enrollmentFilterFields.toYear]
        ? Number(filterParams[enrollmentFilterFields.toYear])
        : undefined,
});
